import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './SectionSpacesMaybe.module.css';

const SpaceIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const CANDIDATE_KEYS = ['spaces', 'spaceTypes'];

/**
 * Renders space-type cards in a horizontal-scroll row.
 *
 * Props:
 *   - publicData
 *   - listingFieldConfigs
 *   - intl
 */
const SectionSpacesMaybe = props => {
  const { publicData, listingFieldConfigs } = props;

  if (!publicData) return null;

  const key = CANDIDATE_KEYS.find(k => Array.isArray(publicData[k]) && publicData[k].length > 0);
  if (!key) return null;

  const rawValues = publicData[key];

  const config = Array.isArray(listingFieldConfigs)
    ? listingFieldConfigs.find(c => c.key === key)
    : null;
  const enumOptions = config?.enumOptions || [];

  const items = rawValues.map(v => {
    const opt = enumOptions.find(o => `${o.option}` === `${v}`);
    return { value: v, label: opt?.label || v };
  });

  return (
    <section className={css.root}>
      <Heading as="h2" rootClassName={css.heading}>
        <FormattedMessage id="ListingPage.spacesTitle" />
      </Heading>
      <div className={css.scroller}>
        <ul className={css.list}>
          {items.map(item => (
            <li key={item.value} className={css.card}>
              <span className={css.iconWrap}>
                <SpaceIcon />
              </span>
              <span className={css.label}>{item.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SectionSpacesMaybe;
